import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ISubscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { WebsocketService } from '../services/util/websocket.service';
import { QuestionService } from '../services/question.service';
import { QuestionControlService } from '../services/question-control.service';
import { LoadingService } from '../services/util/loading.service';
import { AppSettings } from '../app.settings';

declare var $: any;
declare var alert: any;
declare const swal: any;

@Component({
    selector: 'sign-cmp',
    moduleId: module.id,
    templateUrl: 'sign.component.html',
    providers: [QuestionService, QuestionControlService]
})

export class SignComponent implements OnInit {
    model: any = {};
    loading = false;
    user: any = {};
    objToSign: any;
    files: any[];
    pending: number;
    procedureid = '-1';
    mock = false;
    filterCertificate: String = 'ALL';
    readingCertificates = false;
    private subscription: ISubscription;
    look = '';
    currentUser: any; // User;
    attempts: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private wsService: WebsocketService,
        private questionService: QuestionService,
        private cdr: ChangeDetectorRef,
        private loadingService: LoadingService
    ) {
        this.loadingService.enableShowSpinner();
        this.wsService.init();
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.look = localStorage.getItem('look_backend');

        this.subscription = this.wsService.websocket.subscribe(msg => {
            let color = '#ac1f7f';
            if (this.look === 'BLACK') {
                color = '#000000';
            }
            if (msg[0] === '[') {
                this.readingCertificates = false;
                const list = JSON.parse(msg);
                let i, arr;
                if (list.length === 0) {
                    alert('CIPE no válida para firmar este trámite', color);
                    return;
                }
                arr = [];
                let index: number;
                for (i = 0; i < list.length; i++) {
                    // if (list[i].email.indexOf('sanluis.edu.ar') >= 0) {
                    index = i + 1;
                    arr.push({ key: list[i].position + 1, value: list[i].name });
                    // }
                }
                this.user.options = arr;
                this.model.username = arr[0].key;
            } else {
                if (msg[0] === '{') {
                    const fileuploaded = JSON.parse(msg);
                    if (fileuploaded.result === 'OK') {
                        this.disableShowSpinner();
                        this.cdr.detectChanges();
                        this.objToSign = JSON.parse(localStorage.getItem('objToSign'));
                        const redirectUrl = this.objToSign.redirectUrl;
                        localStorage.removeItem('objToSign');
                        this.subscription.unsubscribe();
                        swal({
                            title: 'Firmado!',
                            text: 'Guardado y firmado con éxito.',
                            type: 'success',
                            confirmButtonColor: '#b8465e'
                        });
                        if (redirectUrl) {
                            this.router.navigate([redirectUrl]);
                        } else {
                            this.router.navigate(['/']);
                        }
                        this.disableShowSpinner();
                    } else if (fileuploaded.result === 'ERROR') {
                        swal({
                            title: 'Atención!',
                            text: 'Se produjo un error. Contactese con un administrador.',
                            type: 'warning',
                            confirmButtonColor: '#b8465e'
                        });
                        this.disableShowSpinner();
                    }
                } else if (msg === 'OK') {
                    this.objToSign = JSON.parse(localStorage.getItem('objToSign'));
                    const procedureid = this.objToSign.procedure.id;
                    let code = this.objToSign.procedure.documentId != null ? 'REC' : 'ORDER';
                    const json = {
                        url: this.objToSign.url,
                        xAuthentication: this.objToSign.xAuthentication,
                        selectedCertificate: this.model.username,
                        pin: this.model.password,
                        procedure: {
                            procedureId: procedureid
                        },
                        file: {
                            id: '0',
                            mimeType: 'application/pdf',
                            originalName: 'base64-' + procedureid + '.pdf',
                            base64: this.objToSign.files[0]
                        },
                        code: this.objToSign.procedure.code
                    };
                    this.wsService.websocket.next(JSON.stringify(json));
                } else if (msg === 'CARDREADER_OFF') {
                    swal({
                        title: 'Atención!',
                        text: 'No se detectó lector de CIPE.',
                        type: 'warning',
                        confirmButtonColor: '#b8465e'
                    });
                    this.readingCertificates = false;
                    this.disableShowSpinner();
                }else if (msg.includes('-6')) {
                   
                    swal({
                        title: 'Atención!',
                         text: 'Tarjeta bloqueada',
                        type: 'warning',
                        confirmButtonColor: '#b8465e'
                    });
                    this.readingCertificates = false;
                    this.disableShowSpinner();
                }else if (msg.includes('ERROR VALIDANDO PIN')) {
                    this.attempts = msg.split('- ')[1];
                    swal({
                        title: 'Atención!',
                         text: 'Contraseña incorrecta, ' + this.attempts.toLowerCase(),
                        type: 'warning',
                        confirmButtonColor: '#b8465e'
                    });
                    this.readingCertificates = false;
                    this.disableShowSpinner();
                } else {
                    swal({
                        title: 'Atención!',
                        text: 'No se encontraron certificados. Verifique nuevamente',
                        type: 'warning',
                        confirmButtonColor: '#b8465e'
                    });
                    this.readingCertificates = false;
                    this.disableShowSpinner();
                }
            }
        });
        this.disableShowSpinner();
    }

    ngOnInit() {
        document.querySelector('#top').scrollIntoView();
    }

    changeStyle() {
        if (this.look === 'BLACK') {
            $('button.btn.btn-primary').css('background-color', '#000000');
            $('.card-header').css('background-color', '#000000');
            $('.title').css('background-color', '#000000');
            $('#nav-container').css('display', 'nonoe');
            $('#nav-container-BLACK').css('display', 'block');
        } else {
            $('button.btn.btn-primary').css('background-color', '#ac1f7f');
            $('.card-header').css('background-color', '#ac1f7f');
            $('.title').css('background-color', '#ac1f7f');
            $('#nav-container').css('display', 'block');
            $('#nav-container-BLACK').css('display', 'none');
        }
    }

    getCertificates() {
        this.model.password = '';
        this.objToSign = JSON.parse(localStorage.getItem('objToSign'));
        this.readingCertificates = true;
        if (AppSettings.SING_OID) {
            this.wsService.websocket.next('GET_SIGN_CERTIFICATES SN:' + this.currentUser.person.docNumber);
        } else {
            this.wsService.websocket.next('GET_SIGN_CERTIFICATES');
        }
    }

    validatePIN() {
        this.wsService.websocket.next('PIN' + this.model.password);
        this.loadingService.enableShowSpinner();
    }

    showSpinner() {
        this.cdr.detectChanges();
        return this.loadingService.mustShowSpinner();
    }
    disableShowSpinner() {
        return this.loadingService.disableShowSpinner();
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/sign/sign.component.ts